export interface SearchFormProps<T> {
  onSubmit: (filter: T) => void;
  initialValues: T;
  onReset?: () => void;
}

export enum ContactType {
  Email = 0,
  Phone = 1,
  Link = 2
}

export interface Tag {
  id: string | null;
  name: string;
  slug?: string;
}

export interface Contact {
  id: string;
  contactType: ContactType;
  name: string;
  value: string;
}

export interface ContactBlock {
  id: string;
  title: string;
  slug: string;
  description: string;
  blockOrder: number;
  cards: ContactCard[];
}

export interface ContactCard {
  id: string;
  title: string;
  cardOrder: number;
  contacts: Contact[];
}

export interface EntityContactsView {
  id: string;
  name: string;
  contacts: Contact[];
}

export interface ContactFilters {
  search?: string;
  tags?: string[];
  slug?: string;
  cards?: string[];
}

export interface ContactTagFilter {
  blockId?: string;
  search?: string;
}

export interface ContactFormProps {
  search?: string;
}
